import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Bell, Mail } from "lucide-react";
import { Switch } from "@/components/ui/switch";
import { useApi, errMsg } from "@/lib/api";

export const AlertsToggle = () => {
  const api = useApi();
  const [on, setOn] = useState(null);
  const [recap, setRecap] = useState(false);
  useEffect(() => { api("get", "/me/alerts").then((d) => { setOn(d.tip_alerts); setRecap(d.weekly_recap); }).catch(() => setOn(false)); }, [api]);
  const change = async (v) => {
    setOn(v);
    try { await api("put", "/me/alerts", { tip_alerts: v, weekly_recap: recap }); toast.success(v ? "You'll get an email when tips are published" : "Tip alerts turned off"); }
    catch (e) { setOn(!v); toast.error(errMsg(e)); }
  };
  const changeRecap = async (v) => {
    setRecap(v);
    try { await api("put", "/me/alerts", { tip_alerts: !!on, weekly_recap: v }); toast.success(v ? "You'll get a recap every Monday" : "Monday recap turned off"); }
    catch (e) { setRecap(!v); toast.error(errMsg(e)); }
  };
  return (
    <div className="space-y-2">
    <label className="flex items-center gap-3 rounded-2xl bg-[#131C31] border border-white/5 px-4 py-3 cursor-pointer" data-testid="alerts-toggle-card">
      <Bell className="w-5 h-5 text-blue-400" />
      <span className="text-sm mr-auto">Email me when new tips are published</span>
      <Switch data-testid="alerts-toggle" checked={!!on} disabled={on === null} onCheckedChange={change} />
    </label>
    <label className="flex items-center gap-3 rounded-2xl bg-[#131C31] border border-white/5 px-4 py-3 cursor-pointer" data-testid="recap-toggle-card">
      <Mail className="w-5 h-5 text-blue-400" />
      <span className="text-sm mr-auto">Monday recap of how the weekend's tips went</span>
      <Switch data-testid="recap-toggle" checked={recap} disabled={on === null} onCheckedChange={changeRecap} />
    </label>
    </div>
  );
};
